<template>
  <div id="app">
    <MainNavBar />
    <Carrusel />
    <b-container >
      <b-row>
        <b-col cols="12" md="6" class="p-1">
          <Info />
        </b-col>
        <b-col class="p-1">
          <Products />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6" class="p-1">
          <Services />
        </b-col>
        <b-col class="p-1">
          <Contact />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import MainNavBar from "./components/MainNavBar";
import Carrusel from "./components/Carrusel";
import Info from "./components/InfoCard";
import Products from "./components/Products";
import Services from "./components/Services";
import Contact from "./components/ContactCard";

export default {
  name: "App",
  components: {
    MainNavBar,
    Carrusel,
    Info,
    Products,
    Services,
    Contact,
  },
  data() {
    return {
      status: "not_accepted",
    };
  },
};
</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.MainPageCard {
  padding: 2px;
  margin-top: 5px;
  height: 20rem;
  width: 100%;
  line-height: 1.07143;
  font-weight: 600;
  letter-spacing: -0.005em;
  font-family: "SF Pro Display", "SF Pro Icons", "Helvetica Neue", "Helvetica",
    "Arial", sans-serif;
  background: #f8f8fc;
  box-shadow: 0 0.1rem 0.1rem rgb(0 0 0 / 25%),
    inset 0 -1px 1px rgb(0 0 0 / 25%);
}

</style>
